// services/facturasService.js
/**domain service (lógica pura del negocio).
 * facturasService.js
 * --------------------------------------------------
 * Este archivo contiene la LÓGICA DE NEGOCIO relacionada
 * con la facturación.
 *
 * 👉 Qué SÍ debe ir aquí:
 * - Construcción de facturas
 * - Cálculo de totales
 * - Validaciones de datos
 * - Reglas de negocio (qué es una factura válida)
 *
 * 👉 Qué NO debe ir aquí:
 * - Código de UI (React, estados, componentes)
 * - Acceso a base de datos (Supabase, fetch, axios)
 * - Manejo directo de eventos del usuario
 *
 * Este service NO sabe cómo ni dónde se guardan las facturas,
 * solo sabe CÓMO se construyen y validan.
 */

/**
 * Genera un número de factura incremental.
 * Actualmente usa localStorage como mecanismo simple.
 *
 * En el futuro esto puede moverse a backend
 * sin afectar al resto del sistema.
 */
import { ahora } from "../../../../utils/fechas.js";

export function generarNumeroFactura() {
  const ultimo = Number(localStorage.getItem("ultimaFactura") || 99999);
  const nuevo = ultimo + 1;
  localStorage.setItem("ultimaFactura", nuevo);
  return nuevo;
}

/**
 * Calcula el total de una factura a partir de
 * las órdenes seleccionadas.
 *
 * @param {Array} ordenesSeleccionadas
 * @param {Object} ordenesPorMesa
 * @returns {number} total de la factura
 */

/**
 * Construye una factura completa lista para ser
 * enviada a persistencia o a un flujo de pago.
 *
 * Esta función:
 * - Genera el número de factura
 * - Calcula el total
 * - Arma la estructura estándar de la factura
 *
 * @returns {Object|null} factura construida o null si no hay órdenes
 */
export function construirFactura({ ordenesSeleccionadas }) {
  if (!ordenesSeleccionadas?.length) return null;

  const numeroFactura = generarNumeroFactura();
  const total = ordenesSeleccionadas.reduce((acc, o) => acc + o.total, 0);

  return {
    numeroFactura,
    fecha: ahora(),
    estado: "pendiente",
    total,
    pedidos: ordenesSeleccionadas.map(o => ({
      mesaId: o.mesaId,
      productos: o.productos,
      total: o.total,
    })),
  };
}


